import { Component } from '@angular/core';
import { AuthService } from "../../services/auth.service";
import {QuickPreviewPanelComponent} from "../../../core/quick-preview-panel/quick-preview-panel.component";
import {ActionsContainerComponent} from "../../../core/actions-container/actions-container.component";
import {MatButtonModule} from "@angular/material/button";
import {BackButtonComponent} from "../../../core/back-button/back-button.component";
import {AuthAccountInfoComponent} from "../auth-account-info/auth-account-info.component";


@Component({
  selector: 'auth-user-logout',
  templateUrl: './logout.component.html',
  standalone: true,
  imports: [
    QuickPreviewPanelComponent,
    ActionsContainerComponent,
    MatButtonModule,
    BackButtonComponent,
    AuthAccountInfoComponent
  ]
})
export class LogoutComponent {

  constructor(readonly authService: AuthService) {}

  logout(): void {
    this.authService.logout()
  }
}
